// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BAFrontDeskList--next-sr-only--1seR4kt","BAList":"BAFrontDeskList--BAList--3k3gbTT"};